import styled from 'styled-components';
import LoadDetails from './LoadDetails';
import { colorSchema } from 'utils/style';

export default styled(LoadDetails)`
  display: flex;
  align-items: ${props => (props.bottomAlign ? 'flex-end' : 'flex-start')};

  .load-details {
    display: flex;
    min-width: 320px;
    &__palletes,
    &__mass,
    &__height {
      color: ${colorSchema('grey700')};
      margin-right: 2rem;
    }

    &__extra-icon {
      margin-right: 1rem;
      svg {
        fill: ${colorSchema('grey500')};
        height: 16px;
        width: 30px;
        padding-bottom: 2px;
      }
    }

    &__palletes {
      min-width: 41px;
    }

    &__mass {
      min-width: 69px;
    }

    &__height {
      min-width: 50px;
    }

    &__extras-container {
      display: flex;
      min-width: 120px;
    }
  }
`;
